var _jsxFileName = "/repo/packages/webassets/src/components/Header/Header.js",
  _Object$freeze,
  _this = this;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import OnScroll from './OnScroll';
import SMHeaderContext from './SMHeaderContext';
import { Addon } from './components/Addon';
import HeaderLogo from './components/HeaderLogo';
import MomentiveHeaderLogo from './components/MomentiveHeaderLogo';
import { MobileDrawer } from './components/Drawer/Mobile';
import NavBarAnon from './anonymous/Desktop';
import MobileAnon from './anonymous/Mobile';
import { ValidMenuNameList } from './config/linkInfo';
import { MobileTabletScreen, DesktopScreen } from '../..';
import { BRAND, HEADER_COLOR, HEADER_VARIANT } from './enums';
import './header.scss';
import './utils.scss';
var brandLogoMapper = Object.freeze((_Object$freeze = {}, _defineProperty(_Object$freeze, BRAND.MOMENTIVE, MomentiveHeaderLogo), _defineProperty(_Object$freeze, BRAND.SURVEYMONKEY, HeaderLogo), _Object$freeze));
function getDefaultLogoByBrand(brand) {
  return brandLogoMapper[brand] || HeaderLogo;
}
var SMHeader = function SMHeader(_ref) {
  var isUserAuthenticated = _ref.isUserAuthenticated,
    color = _ref.color,
    lang = _ref.lang,
    variant = _ref.variant,
    isEUDC = _ref.isEUDC,
    actionFlow = _ref.actionFlow,
    user = _ref.user,
    isAnonHeaderSticky = _ref.isAnonHeaderSticky,
    excludeMenuItems = _ref.excludeMenuItems,
    showLoginButton = _ref.showLoginButton,
    showSignupButton = _ref.showSignupButton,
    Logo = _ref.Logo,
    brand = _ref.brand;
  var LogoComponent = Logo || getDefaultLogoByBrand(brand);
  var auth = isUserAuthenticated ? 'auth' : 'anon';
  var headerColor = isUserAuthenticated ? 'primary' : color;
  var headerVariant = isUserAuthenticated ? 'default' : variant;
  return /*#__PURE__*/React.createElement(SMHeaderContext.Provider, {
    value: {
      isUserAuthenticated: isUserAuthenticated,
      lang: lang,
      isEUDC: isEUDC,
      actionFlow: actionFlow,
      user: user,
      excludeMenuItems: excludeMenuItems
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(OnScroll, {
    render: function render(x, y) {
      var headerColorAnon = y > 0 ? 'light' : color;
      var smHeaderColor = isUserAuthenticated ? headerColor : headerColorAnon;
      var defaultColor = headerColorAnon === 'transparent' || headerColorAnon === 'primary';
      var logoColor = defaultColor ? 'alt' : 'primary';
      var mobileMenuColor = defaultColor ? 'alt' : 'secondary';
      var addonLogInColor = defaultColor ? 'alt' : 'secondary';
      var navBarColor = defaultColor ? 'alt' : 'secondary';
      var addonSignUpColor = defaultColor ? 'alt' : 'upgrade';
      var addonSignUpVariant = defaultColor ? 'ghost' : 'default';
      var classNames = classnames("sm-header--".concat(auth), "sm-header--".concat(smHeaderColor), "sm-header--".concat(headerVariant), {
        'sm-header--en': lang === 'en'
      }, {
        'sm-header--sticky': isAnonHeaderSticky && !isUserAuthenticated
      });
      var logoComponentProps = {
        isUserAuthenticated: isUserAuthenticated
      };
      if (brand === BRAND.MOMENTIVE) {
        logoComponentProps.isContrast = smHeaderColor === HEADER_COLOR.LIGHT;
      } else {
        logoComponentProps.variant = variant;
        logoComponentProps.color = logoColor;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: classNames,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 98,
          columnNumber: 13
        }
      }, /*#__PURE__*/React.createElement(MobileTabletScreen, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 99,
          columnNumber: 15
        }
      }, /*#__PURE__*/React.createElement(MobileDrawer, {
        menuColor: mobileMenuColor,
        "data-testid": "Header__MobileDrawer--Anon",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 100,
          columnNumber: 17
        }
      }, /*#__PURE__*/React.createElement(MobileAnon, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 104,
          columnNumber: 19
        }
      }))), /*#__PURE__*/React.createElement(LogoComponent, Object.assign({}, logoComponentProps, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 107,
          columnNumber: 15
        }
      })), /*#__PURE__*/React.createElement(DesktopScreen, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 108,
          columnNumber: 15
        }
      }, /*#__PURE__*/React.createElement(NavBarAnon, {
        color: navBarColor,
        lang: lang,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 109,
          columnNumber: 17
        }
      })), /*#__PURE__*/React.createElement(Addon, {
        addonSignUpColor: addonSignUpColor,
        addonLogInColor: addonLogInColor,
        addonSignUpVariant: addonSignUpVariant,
        variant: variant,
        isUserAuthenticated: isUserAuthenticated,
        showLoginButton: showLoginButton,
        showSignupButton: showSignupButton,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 111,
          columnNumber: 15
        }
      }));
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 7
    }
  }));
};
SMHeader.propTypes = {
  isAnonHeaderSticky: PropTypes.bool,
  color: PropTypes.oneOf(Object.values(HEADER_COLOR)),
  isUserAuthenticated: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  lang: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(Object.values(HEADER_VARIANT)),
  isEUDC: PropTypes.bool.isRequired,
  actionFlow: PropTypes.string,
  user: PropTypes.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  showDrawer: PropTypes.bool,
  excludeMenuItems: PropTypes.arrayOf(PropTypes.oneOf(ValidMenuNameList)),
  showLoginButton: PropTypes.bool,
  showSignupButton: PropTypes.bool,
  alwaysUseAnonymousNav: PropTypes.bool,
  Logo: PropTypes.node,
  brand: PropTypes.oneOf(Object.values(BRAND))
};
SMHeader.defaultProps = {
  isAnonHeaderSticky: true,
  color: 'primary',
  isUserAuthenticated: false,
  showDrawer: true,
  variant: 'default',
  actionFlow: 'header',
  excludeMenuItems: [],
  showLoginButton: true,
  showSignupButton: true,
  alwaysUseAnonymousNav: false,
  Logo: undefined,
  brand: BRAND.SURVEYMONKEY
};
export default SMHeader;
//# sourceMappingURL=Header.js.map